import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formatText } from '../../helpers/value'
import { Element } from '../html/element'
import { Icon } from '../html/icon'
import { selectSentiments } from './slice'
import { getSentimentsThunk } from './thunk'
import PropTypes from 'prop-types'

export const SENTIMENT_TYPE_ID = {
  POSITIVE: 11,
  NEGATIVE: 9,
  NEUTRAL: 10,
}

export const SENTIMENT_TYPE_COLOR = {
  [SENTIMENT_TYPE_ID.POSITIVE]: '#3DA967',
  [SENTIMENT_TYPE_ID.NEGATIVE]: '#E0505B',
  [SENTIMENT_TYPE_ID.NEUTRAL]: '#E8B714',
}

export const SentimentCell = ({
  sentimentName,
  newsTypeIds,
  defaultSentiments,
}) => {
  const dispatch = useDispatch()

  const sentiments = useSelector(selectSentiments)

  const { newsTypeId } =
    (defaultSentiments || sentiments).find((item) =>
      newsTypeIds.includes(item?.newsTypeId),
    ) || {}

  useEffect(() => {
    if (!defaultSentiments) {
      dispatch(getSentimentsThunk())
    }
  }, [])

  const getIconName = () => {
    switch (newsTypeId) {
      case SENTIMENT_TYPE_ID.POSITIVE:
        return 'icon-plus-circle-fill'
      case SENTIMENT_TYPE_ID.NEGATIVE:
        return 'icon-remove-circle'
      case SENTIMENT_TYPE_ID.NEUTRAL:
        return 'icon-circle'
      default:
        return ''
    }
  }

  return (
    <Element className="dFlex alignItemsCenter">
      <Icon
        className={`${getIconName()} cursorDefault`}
        style={{
          color: SENTIMENT_TYPE_COLOR[newsTypeId],
          fontSize: 13,
        }}
      />
      <Element
        elementName="span"
        className="fw600 whiteSpaceNowrap"
        style={{
          marginLeft: 4,
          color: SENTIMENT_TYPE_COLOR[newsTypeId],
        }}
      >
        {formatText(sentimentName)}
      </Element>
    </Element>
  )
}

SentimentCell.propTypes = {
  sentimentName: PropTypes.string,
  newsTypeIds: PropTypes.array,
  defaultSentiments: PropTypes.array,
}

SentimentCell.defaultProps = {
  newsTypeIds: [],
}
